import React, {useEffect, useState} from 'react';
import {useWindowSize} from "@uidotdev/usehooks";
import Header from "../components/Header/Header";
import {Flex, Form, Input, message, Select} from "antd";
import {Fade} from "react-awesome-reveal";
import MyText from "../../components/UI/Text/MyText";
import Footer from "../components/Footer/Footer";
import image from "./bg.png";
import styles from "./micro-qualification.module.css";
import BlockLoading from "../../components/LoadingComponents/BlockLoading";
import cl from "../Home/components/Banner/Banner.module.css";
import IntlMessage, {IntlMessageText} from "../../components/IntlMessage/IntlMessage";
import FormItem from "antd/es/form/FormItem";
import {EmailValidator} from "../../utils/EmailValidator";
import InputMask from "react-input-mask";
import GreyButton from "../../components/UI/Buttons/GreyButton";
import {clrs} from "../../constants/colors";
import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";
import ApplicationService from "../../services/ApplicationService";
import {LocalName} from "../../utils/LocalName";
import {useLocation} from "react-router-dom";

const MicroQualificationsPage = ({id}) => {
    const size = useWindowSize();
    const location = useLocation();
    const data = location.state;

    const [form] = Form.useForm();
    const name = Form.useWatch('name', form);
    const email = Form.useWatch('email', form);
    const telNumber = Form.useWatch('telNumber', form);
    const categoryId = Form.useWatch('categoryId', form);

    const {t} = useTranslation();

    const categoriesListFromRedux = useSelector(state => state.categoriesList);

    const [categories, setCategories] = useState([]);

    const [loading, setLoading] = useState(false);

    function handleSubmit() {
        form.validateFields()
            .then(async () => {
                message.loading(<IntlMessage id={'loading'}/>, 0);
                setLoading(true);
                await ApplicationService.saveApplication(
                    name,
                    email,
                    telNumber.endsWith('_') ? telNumber.slice(0, -1) : telNumber,
                    categoryId)
                    .then(() => {
                        message.destroy();
                        message.success(<IntlMessage id={'successApplicationSend'}/>, 5);
                        form.resetFields();
                        setLoading(false);
                    })
                    .catch((reason) => {
                        message.destroy();
                        if (reason?.response.data === "application already exists") {
                            message.error(<IntlMessage id={'applicationIsAlreadyExists'}/>, 5);
                        } else {
                            message.error(<IntlMessage id={'error'}/>, 5);
                        }
                        setLoading(false);
                    })
            })
            .catch(() => {
                console.log("Validation error!")
            })
    }

    useEffect(() => {
        setCategories(
            categoriesListFromRedux.categories.map(category => {
                return {value: category.id, label: LocalName.getName(category)}
            })
        )
    }, [categoriesListFromRedux.categories]);
    return (
        <div>
            <Header/>
            <Flex style={{width: "100%", position: "relative", padding: "120px 20px 20px 20px"}} align={"center"}
                  justify={"center"}>
                <Flex gap={50} style={{width: "100%", maxWidth: 1440, position: "relative"}} vertical
                      align={"flex-start"} justify={"flex-start"}>
                    <Flex style={{
                        width: "100%",
                        borderBottomRightRadius: 20,
                        borderBottomLeftRadius: 20,
                        height: 400,
                        position: "relative",
                        overflow: "hidden"
                    }} align={"flex-start"} justify={"center"} vertical>
                        <Fade triggerOnce={true} style={{zIndex: 1,}} cascade damping={0.15} direction={"down"}>
                            <MyText style={{
                                fontSize: size.width < 768 ? "1.5rem" : "3rem",
                                color: "white",
                                zIndex: 1,
                                paddingLeft: size.width < 768 ? 20 : 40,
                                fontWeight: "bold",
                                textTransform: "uppercase"
                            }}>
                                <IntlMessage id={'microQEP'}/>
                            </MyText>
                            <MyText
                                style={{fontSize: size.width < 768 ? "1.5rem" : "2rem", color: "white", zIndex: 1, paddingLeft: size.width < 768 ? 20 : 40, fontWeight: 300}}>
                                {LocalName.getName(data.microQEP)}
                            </MyText>
                        </Fade>
                        <div style={{
                            width: "100%",
                            height: "100%",
                            position: "absolute",
                            top: 0,
                            left: 0,
                            backgroundImage: `url(${image})`,
                            backgroundPosition: "center",
                            backgroundAttachment: "fixed",
                        }}/>
                        <div style={{
                            width: "100%",
                            height: "100%",
                            position: "absolute",
                            top: 0,
                            left: 0,
                            backgroundColor: "black",
                            opacity: 0.7
                        }}/>
                    </Flex>
                    <Flex gap={80} style={{width: "100%", maxWidth: 1440, position: "relative"}} vertical
                          align={"flex-start"} justify={"flex-start"}>
                        <Flex style={{width: "100%", position: "relative"}} align={"flex-start"} justify={"center"}
                              vertical gap={20}>
                            <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                                <MyText strong size={"x-large"} style={{fontSize: size.width < 768 ? "1.75rem" : "2.5rem"}}>
                                    <IntlMessage id={'microqualPage.passport'}/>
                                </MyText>
                                <Flex vertical gap={8}>
                                    <Fade triggerOnce={true} cascade damping={0.2} direction={"down"}>
                                        <p>
                                            <strong>{IntlMessageText.getText({id: "educationField"})}: </strong>{LocalName.getName(data.educationField)}
                                        </p>
                                        <p>
                                            <strong>{IntlMessageText.getText({id: "trainingDirection"})}: </strong>{LocalName.getName(data.trainingDirection)}
                                        </p>
                                        <p>
                                            <strong>{IntlMessageText.getText({id: "groupEP"})}: </strong>{LocalName.getName(data.groupEP)}
                                        </p>
                                        <p>
                                            <strong>{IntlMessageText.getText({id: "licenceNumberTo"})}: </strong>{data.licenceNumber}
                                        </p>
                                        <p>
                                            <strong>{IntlMessageText.getText({id: "creditVolume"})}: </strong>{data.creditNum}
                                        </p>
                                        <p>
                                            <strong>{IntlMessageText.getText({id: "registerNumber"})}: </strong>{data.regNumber}
                                        </p>
                                        <p>
                                            <strong>{IntlMessageText.getText({id: "registerDate"})}: </strong>{data.regDate}
                                        </p>
                                        <p>
                                            <strong>{IntlMessageText.getText({id: "learnLanguage"})}: </strong>{LocalName.getName(data.learnLanguage)}
                                        </p>
                                        <p>
                                            <strong>{IntlMessageText.getText({id: "partnerOrg"})}: </strong>{LocalName.getName(data.partnerOrg)}
                                        </p>
                                    </Fade>
                                </Flex>
                            </Fade>
                        </Flex>
                        <Flex style={{width: "100%", position: "relative"}} align={"flex-start"} justify={"center"}
                              vertical gap={30}>
                            <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                                <MyText strong size={"x-large"} style={{fontSize: size.width < 768 ? "1.75rem" : "2.5rem"}}>
                                    <IntlMessage id={"microqualPage.description"}/>
                                </MyText>
                                <Flex vertical gap={8}>
                                    <Fade triggerOnce={true} cascade damping={0.2} direction={"down"}>
                                        <MyText strong><IntlMessage id={"mainDirectionEP"}/></MyText>
                                        <p>{LocalName.getName(data.mainDirectionEP)}</p>
                                    </Fade>
                                </Flex>
                                <Flex vertical gap={8}>
                                    <Fade triggerOnce={true} cascade damping={0.2} direction={"down"}>
                                        <MyText strong><IntlMessage id={"goalEPMQ"}/></MyText>
                                        <p>{LocalName.getName(data.goalEPMQ)}</p>
                                    </Fade>
                                </Flex>
                                <Flex vertical gap={8}>
                                    <Fade triggerOnce={true} cascade damping={0.2} direction={"down"}>
                                        <MyText strong><IntlMessage id={"tasksEPMQ"}/></MyText>
                                        {data.tasksEPMQ.map((task) => (
                                            <p>- {LocalName.getName(task)}</p>
                                        ))}
                                    </Fade>
                                </Flex>
                            </Fade>
                        </Flex>
                        <Flex style={{width: "100%", position: "relative"}} align={"flex-start"} justify={"center"}
                              vertical gap={20}>
                            <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                                <MyText strong size={"x-large"} style={{fontSize: size.width < 768 ? "1.75rem" : "2.5rem"}}>
                                    <IntlMessage id={"microqualPage.results"}/>
                                </MyText>
                                <Flex vertical gap={8}>
                                    <Fade triggerOnce={true} cascade damping={0.2} direction={"down"}>
                                        {data.formLearnResult.map((result, index) => (
                                            <p><strong>PO {index + 1}.</strong> {LocalName.getName(result)}</p>
                                        ))}
                                    </Fade>
                                </Flex>
                            </Fade>
                        </Flex>
                        <Flex style={{width: "100%", position: "relative"}} align={"flex-start"} justify={"center"}
                              vertical gap={20}>
                            <Fade triggerOnce={true} cascade damping={0.15} style={{width: "100%", overflowX: "auto"}}>
                                <MyText strong size={"x-large"} style={{fontSize: size.width < 768 ? "1.75rem" : "2.5rem"}}>
                                    <IntlMessage id={"microqualPage.resultsDescription"}/>
                                </MyText>
                                <Fade triggerOnce={true} cascade damping={0.2} style={{width: "100%", overflowX: "auto"}}>
                                    <table className={styles.studyPlanTable} style={{minWidth: 1000}} >
                                        <tr>
                                            <th><MyText center strong>№</MyText></th>
                                            <th><MyText center strong><IntlMessage id={"amOpDisciplineName"}/></MyText>
                                            </th>
                                            <th><MyText center strong><IntlMessage id={"amOpDisciplineDesc"}/></MyText>
                                            </th>
                                            <th><MyText center strong><IntlMessage id={"amOpCreditNum"}/></MyText></th>
                                            <th><MyText center strong><IntlMessage id={"amOpAcademHrsNum"}/></MyText>
                                            </th>
                                            <th><MyText center strong><IntlMessage
                                                id={"amOpDisciplineCompetenceCodes"}/></MyText></th>
                                        </tr>
                                        <tbody className={styles.sectionContent}>
                                        {data.disciplines.map((discipline, index) => (
                                            <tr>
                                                <td>{index + 1}.</td>
                                                <td>{LocalName.getName(discipline.name)}</td>
                                                <td>{LocalName.getName(discipline.desc)}</td>
                                                <td>{discipline.creditNum}</td>
                                                <td>{discipline.acaHrNum}</td>
                                                <td>{discipline.codes}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                    </table>
                                </Fade>
                            </Fade>
                        </Flex>
                    </Flex>
                    <Flex style={{width: "100%", position: "relative"}} gap={20} align={"center"} justify={"center"}>
                        <Fade triggerOnce={true} cascade style={{width: '100%'}}>
                            <Form form={form} onSubmit={handleSubmit}>
                                <BlockLoading isLoading={loading}/>
                                <div>
                                    <p className={cl.bannerFormText}><IntlMessage id={'bannerText2'}/></p>
                                    <p className={cl.bannerFormText}><IntlMessage id={'bannerText3'}/></p>
                                    <br/>
                                </div>

                                <FormItem rules={[{
                                    required: true,
                                    message: <IntlMessage id={'bannerFormNameError'}/>,
                                },
                                ]} name="name">
                                    <Input
                                        placeholder={IntlMessageText.getText({id: 'name'})}/>
                                </FormItem>
                                <FormItem rules={[{
                                    required: true,
                                    message: <IntlMessage id={'bannerFormEmailError'}/>,
                                },
                                    ({getFieldValue}) => ({
                                        validator(_, value) {
                                            if (EmailValidator.isValid(value)) {
                                                return Promise.resolve();
                                            }
                                            return Promise.reject(new Error(t('emailRules')));
                                        },
                                    }),
                                ]} name="email">
                                    <Input
                                        placeholder={IntlMessageText.getText({id: 'email'})}/>
                                </FormItem>
                                <FormItem rules={[{
                                    required: true,
                                    message: <IntlMessage id={'bannerFormTelError'}/>,
                                },
                                ]} name="telNumber">
                                    <InputMask
                                        mask="+9 (999) 999-9999"

                                        placeholder={IntlMessageText.getText({id: 'telNumber'})}
                                    >
                                        {(inputProps) => <Input {...inputProps} />}
                                    </InputMask>
                                    {/*<Input  placeholder={IntlMessageText.getText({id: 'telNumber'})}/>*/}
                                </FormItem>
                                <FormItem rules={[{
                                    required: true,
                                    message: <IntlMessage id={'requiredField'}/>,
                                },
                                ]} style={{width: "100%", padding: 0}} name="categoryId">
                                    <Select
                                        options={categories}
                                        placeholder={<IntlMessage id={'categoryCourse'}/>}
                                    />
                                </FormItem>
                                <FormItem>
                                    <Flex style={{width: "100%"}} align={"center"} justify={"center"}>
                                        <GreyButton onClick={handleSubmit} backgroundColor={clrs.blackerBlue}
                                                    fontColor={clrs.white}>
                                            <IntlMessage id={'send'}/>
                                        </GreyButton>
                                    </Flex>
                                </FormItem>
                            </Form>
                        </Fade>
                    </Flex>
                </Flex>
            </Flex>
            <Footer/>
        </div>
    );
};

export default MicroQualificationsPage;